function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 26a16 16 0 00-4 1l-1 1a1 1 0 00-1 0 1 1 0 000 1c0 2 3 2 4 2h17l15 1c3 0 8 0 10-3 1-2-1-6-4-6l-22 1a96 96 0 00-14 2zm1 16c6 3 13 2 20 2l23-3a3 3 0 10-1-6c-14 2-27 5-42 5a1 1 0 000 2z",
  fill: "#e0dfe6"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M76 21a1 1 0 00-2-1c-5 6-1 16 1 24l-12 2-15 2-27 2a1 1 0 000 1l28 2c9 0 19 1 27-2a3 3 0 002-1c2 0 4-1 3-4-3-8-8-16-5-25z",
  fill: "#e0dfe6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32 27a5 5 0 001 2 4 4 0 001 1 6 6 0 001 1 6 6 0 007 0 6 6 0 002-3c1-1-12-2-12-1zm10 10a5 5 0 001 2 4 4 0 001 1 6 6 0 001 1 6 6 0 007 0 6 6 0 002-3c1-1-12-2-12-1z",
  fill: "#9df3f0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M76 21a2 2 0 00-1-1h-8l-1-9a2 2 0 000-1 2 2 0 00-1 0h-8V2a2 2 0 000-1 2 2 0 00-1-1L2 1a2 2 0 00-2 2 197 197 0 000 21v5a2 2 0 002 1h7l1 4v5a2 2 0 001 1h8v9a2 2 0 002 1l54-1a2 2 0 002-1l-1-17V21zm-65 6H3V4l51-1v8l1 15-44 1zm31 2a5 5 0 01-4 2 5 5 0 01-3-2zm-29 8v-3l-1-4h4v4a2 2 0 002 1h4a13 13 0 003 0 2 2 0 00-1-3 16 16 0 01-4 0h-1v-2l12-1a9 9 0 007 5 8 8 0 008-5h10a1 1 0 002-1 29 29 0 000 3l-7 1a2 2 0 000 3h1l7-1h1a2 2 0 001-1v-2a27 27 0 010-3v-1a2 2 0 10-3 0l-1-9h1v5a2 2 0 002 1 2 2 0 001-1v-6a2 2 0 00-2-2h-2v-2h6l1 8v15l-51 1zm39 2a5 5 0 01-4 2 6 6 0 01-4-2zm-30 8v-7h4v4a2 2 0 001 1h5a13 13 0 002 0 2 2 0 000-3 16 16 0 01-4 0h-1v-2l11-1a9 9 0 008 5c3 0 6-2 8-5h10a2 2 0 001-2v-9l1 5a2 2 0 001 1 2 2 0 002-1v-6a2 2 0 00-2-2h-2v-2h6v8l1 15-52 1z",
  fill: "#525d7d"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16a2 2 0 002-2v-1l-1-3a24 24 0 006 0 2 2 0 10-1-3 23 23 0 01-5 0H8a2 2 0 00-2 2l1 4v1a2 2 0 001 2z",
  fill: "#525d7d"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15 22a16 16 0 01-4 0h-1v-4a2 2 0 00-2-2 1 1 0 00-1 2v6a2 2 0 001 1h5a12 12 0 002 0 2 2 0 100-3zM43 8a32 32 0 015 0h1v5a2 2 0 001 1h1a2 2 0 001-1V7a2 2 0 00-2-1l-2-1a45 45 0 00-6 0 2 2 0 001 3z",
  fill: "#525d7d"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M28 22a26 26 0 003-2 2 2 0 011 0h1a5 5 0 001-5 6 6 0 00-2-4 4 4 0 00-1 0 6 6 0 00-2-1 6 6 0 00-6 2 6 6 0 001 8 7 7 0 004 2z",
  fill: "#9df3f0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M52 21a27 27 0 010-3v-1a2 2 0 00-3 0v1a29 29 0 000 4h-7a2 2 0 000 3h8a2 2 0 002-2v-2zM28 8a11 11 0 00-1 0c-4 0-6 4-6 8s4 8 8 8c6 0 8-5 8-8 0-5-4-8-9-8zm1 13c-3 0-5-2-5-5s1-5 3-5a8 8 0 011 0c4 0 6 2 6 5 0 1-1 5-5 5zm42 20a27 27 0 01-1-3v-1a2 2 0 10-3 0v1a29 29 0 001 4h-7a2 2 0 000 3h8a2 2 0 002-2v-2z",
  fill: "#525d7d"
});

var SvgCash = function SvgCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 53"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default SvgCash;